import React from 'react'
import "../../CSS/Blog/Pyscript.css"
import FooTer from "../footer"
export default function Pyscript() {

    return (
        <div id='mainPy'>
            <h1 id="start">All Basic About Pyscript</h1>
            <hr />
            <p className="hd">Basics About Pyscript And Some Uses</p>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/HvxZdnYQqkc" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
            </div>
            <div className="yt-visit">
                <p id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </p>
                <a id="cd" rel="noreferrer" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" target="_blank"><button>Code Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) HTML<br />
                2) CSS<br />
                3) JAVASCRIPT (JS)<br />
                4) Pyscript <br />
            </p>
            <p className="q">
                What Is PYscript?
            </p>
            <p className="ans">
                PyScript is a Python front-end framework that enables users to construct Python programs using an HTML interface in the browser.
            </p>
            <p className="q">
                Pyscript Installation In website...
            </p>
            <div className="py-s">
                <p className="py-t" id='py2'>{`
<link rel="stylesheet" href="https://pyscript.net/alpha/pyscript.css" />
<script defer src="https://pyscript.net/alpha/pyscript.js"></script>`}</p>
            </div>
            <p className="q">
                Pyscript Codeing Like...
            </p>
            <div className="py-s">
                <p className="py-t">
                    {`<Pyscript>
        print("Hello World)
        <Pyscript/>`}
                </p>
            </div>
            <p className="q">
                :: Go To Py Script Official Documentation ::
            </p>
            <div className="pygo">
                <a id="pysc" href="https://pyscript.net/">Pyscript Official Site</a>
            </div>
            <p className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </p>
            <FooTer/>
        </div>
    )
}
